export default "assets/images/icons/twitter-72af6e8d.svg";